// components/Services.js
import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '📞',
      title: 'Call + WB Verified Leads',
      price: '₹35,000',
      period: 'for 100 Leads',
      features: [
        'Pre-qualified through phone calls/Whatsapp',
        'In-house verification team',
        'Access to audio recordings',
        'High-intent buyers confirmed',
        'Best for real estate, health, finance'
      ],
      popular: false
    },
    {
      id: 2,
      icon: '🔐',
      title: 'OTP Verified Leads',
      price: '₹25,000',
      period: 'for 100 Leads',
      features: [
        'Mobile OTP verification',
        'AI-filtered for quality',
        'Detailed form submissions',
        'Fast-moving opportunities',
        'Ideal for coaching centers, SMBs'
      ],
      popular: true
    },
    {
      id: 3,
      icon: '💬',
      title: 'WhatsApp Verified Leads',
      price: '₹20,000',
      period: 'for 100 Leads',
      features: [
        'Direct WhatsApp messages',
        'Multi-step form funnel',
        'Low-friction engagement',
        'High conversion rate',
        'Perfect for retail, clinics, consultants'
      ],
      popular: false
    }
  ];

  return (
    <section id="services" className="services-section fade-in-section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Three powerful lead generation solutions tailored to your needs
        </p>

        <div className="services-grid">
          {services.map((service) => (
            <div 
              key={service.id} 
              className={`service-card ${service.popular ? 'popular' : ''}`}
            >
              {service.popular && <div className="popular-badge">Most Popular</div>}
              
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              
              <div className="service-pricing">
                <div className="service-price">{service.price}</div>
                <div className="service-period">{service.period}</div>
              </div>

              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button className={`service-button ${service.popular ? 'popular-button' : ''}`}>
                Get Started
              </button>
            </div>
          ))}
        </div>

        <div className="services-footer">
          <p>All leads are delivered via WhatsApp and Google Sheets in real time</p>
          <p>100% verified contacts with proper tags and filters</p>
        </div>
      </div>
    </section>
  );
};

export default Services;